import React, { Component } from 'react';
import Loading from './Loading';
import {_Alert, _getToken, _post, _isLogin, variable} from "./Function";

class PaymentItem extends Component {

    constructor(props){
        super(props);
        this.state = {
            month: this.props.match.params.month,
            year: this.props.match.params.year,
            loadingShow: true,
            bill : [],
            is_bill: false,
        }
        _isLogin().then( value =>{
            if(value)
                this.getBill();
        })
    }

    getBill = () => {
        const { month, year } = this.state
        let param = { token: _getToken(), platform: variable().platform, month: month, year: year };
        _post("get.bill.list.php", param).then( res => {

            this.setState({
                loadingShow : false,
                bill : res.data.data,
                is_bill: !!res.data.status
            });

        }).catch((err) => {
            this.setState({loadingShow: false});
            _Alert('error');
        })
    }

    openBill = (url) =>{
        console.log("open ", url)
        window.open(url, "_blank")
    }

    listBill = () => {
        const { bill } = this.state
        return (
            <div>
                <table className="table">
                    <tbody>
                    {
                        bill.map(bill => (
                            <tr onClick={(e) => { this.openBill(bill.url)}}>
                                <td>({bill.bill_no})</td>
                                <td style={{textAlign: 'right'}}>
                                    <i className="fas fa-arrow-alt-circle-right"></i>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        return (
            <div>
                <Loading show={this.state.loadingShow} />
                <div className="card">
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-print"></i></div>
                        <div className="card-title-text">ใบเสร็จ</div>
                    </div>
                    <div className="card-content">
                        {
                            this.state.is_bill ? this.listBill() : <div className="no-data">ไม่พบใบเสร็จ</div>
                        }
                    </div>
                </div>
            </div>
        )
    }

}

export default PaymentItem;
